import _RadioGroup from "@material-ui/core/esm/RadioGroup";
import _Radio from "@material-ui/core/esm/Radio";
import _FormLabel from "@material-ui/core/esm/FormLabel";
import _FormControl from "@material-ui/core/esm/FormControl";
import _Box from "@material-ui/core/esm/Box";
import _FormHelperText from "@material-ui/core/esm/FormHelperText";
import _Checkbox from "@material-ui/core/esm/Checkbox";
import _FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import _Switch from "@material-ui/core/esm/Switch";
import _TextField from "@material-ui/core/esm/TextField";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3]; props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import { Autocomplete } from "./Autocomplete";
import { PasswordAdornment } from "./Adornments";
import { ImagePicker } from "./ImagePicker";
import { DatePicker, TimePicker } from '@material-ui/pickers';
import DateIcon from '@material-ui/icons/TodayRounded';
import TimeIcon from '@material-ui/icons/AccessTime';
export const renderAutocomplete = _ref => {
  let index = _ref.index,
      formik = _ref.formik,
      field = _ref.field,
      inputProps = _ref.inputProps,
      isMultiSelect = _ref.isMultiSelect,
      ignoreInputErrorStyle = _ref.ignoreInputErrorStyle;
  return React.createElement(Autocomplete, _extends({
    key: index,
    field: field,
    inputProps: inputProps,
    multiple: isMultiSelect,
    limitTags: isMultiSelect ? 4 : undefined,
    error: _get(formik.touched, field.name) && _get(formik.errors, field.name) && !ignoreInputErrorStyle && true,
    helperText: _get(formik.touched, field.name) && _get(formik.errors, field.name),
    onChange: formik.setFieldValue,
    options: field.options,
    value: _get(formik.values, field.name)
  }, field));
};
export const renderTextField = _ref2 => {
  let index = _ref2.index,
      formik = _ref2.formik,
      field = _ref2.field,
      inputProps = _ref2.inputProps,
      ignoreInputErrorStyle = _ref2.ignoreInputErrorStyle,
      autoFocus = _ref2.autoFocus,
      _ref2$passwordInputs = _ref2.passwordInputs,
      passwordInputs = _ref2$passwordInputs === void 0 ? {} : _ref2$passwordInputs;
  const getShowPasswordStatus = passwordInputs.getShowPasswordStatus,
        handleClickShowPassword = passwordInputs.handleClickShowPassword,
        handleMouseDownPassword = passwordInputs.handleMouseDownPassword;
  return React.createElement(_TextField, _extends({
    rows: field.type === 'textarea' && inputProps ? inputProps.multilineRows : undefined
  }, field, {
    autoFocus: autoFocus && index === 0,
    disabled: field.disabled,
    id: field.id,
    name: field.name,
    label: field.label,
    type: field.type === 'password' && getShowPasswordStatus(field.name) ? 'text' : field.type,
    placeholder: field.placeholder,
    key: "form-".concat(field.name, "-").concat(index),
    multiline: field.type === 'textarea',
    InputProps: {
      endAdornment: field.type === 'password' && _jsx(PasswordAdornment, {
        fieldStatus: getShowPasswordStatus(field.name),
        onClick: () => handleClickShowPassword(field.name),
        onMouseDown: () => handleMouseDownPassword(field.name)
      })
    },
    value: _get(formik.values, field.name),
    onChange: formik.handleChange,
    error: _get(formik.touched, field.name) && _get(formik.errors, field.name) && !ignoreInputErrorStyle && true,
    helperText: _get(formik.touched, field.name) && _get(formik.errors, field.name)
  }, inputProps));
};
export const renderSwitch = _ref3 => {
  let index = _ref3.index,
      formik = _ref3.formik,
      field = _ref3.field;
  return React.createElement(_FormControlLabel, _extends({
    key: "form-".concat(field.name, "-").concat(index)
  }, field.formControlLabelProps, {
    control: React.createElement(_Switch, _extends({}, field, {
      checked: _get(formik.values, field.name),
      onClick: () => formik.setFieldValue(field.name, !_get(formik.values, field.name))
    })),
    label: field.label
  }));
};
export const renderCheckbox = _ref4 => {
  let index = _ref4.index,
      formik = _ref4.formik,
      field = _ref4.field;
  const checkbox = React.createElement(_Checkbox, _extends({}, field, {
    key: "form-".concat(field.name, "-").concat(index, "-checkbox"),
    checked: _get(formik.values, field.name),
    onClick: () => formik.setFieldValue(field.name, !_get(formik.values, field.name))
  }));

  const error = _get(formik.touched, field.name) && _get(formik.errors, field.name);

  return !!field.label ? _jsx(_FormControl, {
    fullWidth: true,
    error: !!error
  }, void 0, React.createElement(_FormControlLabel, _extends({
    key: "form-".concat(field.name, "-").concat(index)
  }, field.formControlLabelProps, {
    control: checkbox,
    label: field.label
  })), !!error && _jsx(_Box, {
    ml: 1
  }, void 0, _jsx(_FormHelperText, {}, void 0, error))) : checkbox;
};
export const renderRadioGroup = _ref5 => {
  let index = _ref5.index,
      formik = _ref5.formik,
      field = _ref5.field;
  return React.createElement(_FormControl, _extends({}, field.formControlProps, {
    key: "form-".concat(field.name, "-").concat(index),
    component: "fieldset"
  }), React.createElement(_FormLabel, _extends({}, field.formLabelProps, {
    component: "legend"
  }), field.label), React.createElement(_RadioGroup, _extends({}, field, {
    value: _get(formik.values, field.name),
    onChange: formik.handleChange
  }), field.options.map(option => React.createElement(_FormControlLabel, _extends({}, field.formControlLabelProps, {
    label: option.label,
    value: option.name,
    control: React.createElement(_Radio, field.radioProps)
  })))));
};

var _ref7 = /*#__PURE__*/_jsx(DateIcon, {});

export const renderDatePicker = _ref6 => {
  let index = _ref6.index,
      formik = _ref6.formik,
      field = _ref6.field,
      inputProps = _ref6.inputProps,
      ignoreInputErrorStyle = _ref6.ignoreInputErrorStyle;
  return React.createElement(DatePicker, _extends({
    key: "form-".concat(field.name, "-").concat(index),
    InputProps: {
      endAdornment: _ref7
    },
    autoOk: true
  }, inputProps, field, {
    value: _get(formik.values, field.name),
    onChange: date => {
      formik.setFieldValue(field.name, date);
    },
    error: _get(formik.touched, field.name) && _get(formik.errors, field.name) && !ignoreInputErrorStyle && true,
    helperText: _get(formik.touched, field.name) && _get(formik.errors, field.name)
  }));
};

var _ref9 = /*#__PURE__*/_jsx(TimeIcon, {});

export const renderTimePicker = _ref8 => {
  let index = _ref8.index,
      formik = _ref8.formik,
      field = _ref8.field,
      inputProps = _ref8.inputProps,
      ignoreInputErrorStyle = _ref8.ignoreInputErrorStyle;
  return React.createElement(TimePicker, _extends({
    key: "form-".concat(field.name, "-").concat(index),
    InputProps: {
      endAdornment: _ref9
    },
    autoOk: true,
    mask: "__:__ _M"
  }, inputProps, field, {
    value: _get(formik.values, field.name),
    onChange: time => {
      formik.setFieldValue(field.name, time);
    },
    error: _get(formik.touched, field.name) && _get(formik.errors, field.name) && !ignoreInputErrorStyle && true,
    helperText: _get(formik.touched, field.name) && _get(formik.errors, field.name)
  }));
};
export const renderImagePicker = _ref10 => {
  let index = _ref10.index,
      formik = _ref10.formik,
      field = _ref10.field;

  const values = _get(formik.values, field.name);

  return React.createElement(ImagePicker, _extends({}, field, {
    key: "form-".concat(field.name, "-").concat(index),
    values: Array.isArray(values) ? values : !values || _isEmpty(values) ? [] : [values],
    setValues: values => formik.setFieldValue(field.name, field.multiple ? values : values[values.length - 1] || null),
    error: _get(formik.touched, field.name) && _get(formik.errors, field.name),
    helperText: _get(formik.touched, field.name) && _get(formik.errors, field.name)
  }));
};